import React from 'react';
import { PropTypes } from 'prop-types';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

export default function DownloadBtns({
  handlePdf, handleXcl, floatSide, handleSummary, downloading,
}) {
  return (
    <div style={{ float: floatSide, display: 'flex', alignItems: 'center' }}>
      {downloading && <span style={{ marginRight: 12 }}>Downloading...</span>}
      <Button.Group>
        <Button title="Download as PDF" type="primary" icon={<DownloadOutlined />} color="green" loading={downloading} disabled={downloading} onClick={handlePdf}>PDF</Button>
        <Button title="Download as Excel" type="primary" icon={<DownloadOutlined />} loading={downloading} disabled={downloading} onClick={handleXcl}>XLS</Button>
        {handleSummary && (
        <Button
          title="Download as PDF"
          type="primary"
          icon={<DownloadOutlined />}
          loading={downloading}
          disabled={downloading}
          onClick={handleSummary}
        >
          Summary
        </Button>
        )}
      </Button.Group>
    </div>
  );
}

DownloadBtns.propTypes = {
  handlePdf: PropTypes.func.isRequired,
  handleXcl: PropTypes.func.isRequired,
  floatSide: PropTypes.string,
  handleSummary: PropTypes.func,
  downloading: PropTypes.bool,
};

DownloadBtns.defaultProps = {
  floatSide: null,
  handleSummary: null,
  downloading: false,
};
